import React from "react";
import sunny from "../../images/weather/sunny.svg"
import rainy from "../../images/weather/rainy.svg"
import stormy from "../../images/weather/stormy.svg"
import cloudy from"../../images/weather/cloudy.svg"
import question from "../../images/weather/questionmark.svg"
import styled from "styled-components";
const Weather = ({projects}) => {
    const sunnyCount = projects.filter(p => p.weather === "sunny").length
    const cloudyCount = projects.filter(p => p.weather === "cloudy").length
    const rainyCount = projects.filter(p => p.weather === "rainy").length
    const stormyCount = projects.filter(p => p.weather === "stormy").length
    const questionCount = projects.filter(p => p.weather === null).length
    return(
        <WeatherBlock >
            <p className="enjoy-block-title">Météos des projets</p>
            <WeatherCard>
                <WeatherCount>
                    <img src={sunny} alt=""/>
                        <p>{sunnyCount}</p>
                </WeatherCount>
                <div className="weather-desc" >plein soleil = le projet se déroule très bien ! votre équipe ne rencontre aucune difficulté pour le moment.</div>
            </WeatherCard>
            <WeatherCard>
                <WeatherCount>
                    <img src={cloudy} alt=""/>
                        <p>{cloudyCount}</p>
                </WeatherCount>
                <div className="weather-desc" >éclaircie = le projet se poursuit et votre équipe a identifié quelques freins, mais rien de gênant pour l'avancée du projet</div>
            </WeatherCard>
            <WeatherCard>
                <WeatherCount>
                    <img src={rainy} alt=""/>
                        <p>{rainyCount}</p>
                </WeatherCount>
                <div className="weather-desc" >pluie : le projet est freiné par des difficultés importantes. l'équipe projet a besoin d'aide pour lever ces freins.</div>
            </WeatherCard>
            <WeatherCard>
                <WeatherCount>
                    <img src={stormy} alt=""/>
                        <p>{stormyCount}</p>
                </WeatherCount>
                <div className="weather-desc" >tempête = le projet est stoppé ! les difficultés rencontrées sont trop lourdes et le projet ne peut suivre son cours.</div>
            </WeatherCard>
            <WeatherCard>
                <WeatherCount>
                    <img src={question} alt=""/>
                        <p>{questionCount}</p>
                </WeatherCount>
                <div className="weather-desc">point d'interrogation = projet qui n'a pas eu encore d'attribution de météo</div>
            </WeatherCard>
        </WeatherBlock>
    )
}
export default Weather

const WeatherBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media print{
    gap: 0.4rem;
  }
`

const WeatherCard = styled.div`
  display: grid;
  grid-template-columns: 35% 60%;
  gap: 1.5rem;
  img{
    width: 40px;
  }

  .weather-desc{
    text-align: right;
    align-self: center;
    color: #4909aa;
    font-size: 14px;
    text-transform: lowercase;
  }
  
  @media screen and (min-width: 1300px){

    img{
      max-width: 70%;
    }

    .weather-desc{
      text-align: right;
      align-self: center;
      color: #4909aa;
      font-size: 16px;
    }
  }
  @media print{
    grid-template-columns: 30% 70%;
    grid-gap: 0.8rem;
    img{
      max-width: 50%;
    }
    .weather-desc{
      font-size: 10px;
    }
  }
  
`

const WeatherCount = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.8rem;
  border-radius: 15px;
  box-shadow: rgba(0, 0, 0, 0.12) 0 6px 16px;
  -webkit-print-color-adjust: exact;
  -webkit-filter: opacity(1);

  p {
    font-size: 22px;
    font-weight: bold;
    margin: 0;
  }
  @media print{
    padding: 0.5rem;
    
    p{
      font-size: 16px;
    }
  }
`